import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CompetitionIndividualRankingsStore, CompetitionStore, QuotesCompetitionStore } from 'src/app/common-page-components/stores/entities-store/competition-store';
import { CompetitionsNewsStore } from 'src/app/common-page-components/stores/entities-store/competitions-news-store';
import { CompetitionsGalleryStore } from '../../common-page-components/stores/entities-store/competitions-gallery.store.';
import { CompetitionDocumentStore } from '../../common-page-components/stores/entities-store/competition-documents-store';
import { CompetitionInformationStore } from '../../common-page-components/stores/entities-store/competition-store';
import { CompetitionsDayReviewNewsStore } from '../../common-page-components/stores/entities-store/competitions-day-review-news-store';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class CompetitionInitService {
    constructor(http, injector) {
        this.http = http;
        this.injector = injector;
        /**
         * The ranking store items.
         *
         * @memberof FiltersCompetitionRankingService
         */
        this.rankingStore = new CompetitionIndividualRankingsStore(this.http, this.injector);
        /**
         * The competition news store.
         *
         * @type {CompetitionsNewsStore}
         * @memberof CompetitionInitService
         */
        this.competitionNewsStore = new CompetitionsNewsStore(this.http);
        /**
         * The competition day review news store.
         *
         * @type {CompetitionsNewsStore}
         * @memberof CompetitionInitService
         */
        this.competitionDayReviewNewsStore = new CompetitionsDayReviewNewsStore(this.http);
        /**
         * The competition store.
         *
         * @memberof CompetitionInitService
         */
        this.competitionStore = new CompetitionStore(this.http, this.injector);
        /**
         * The competitions gallery store.
         *
         * @memberof CompetitionInitService
         */
        this.competitionGalleryStore = new CompetitionsGalleryStore(this.injector, this.http);
        /**
         * The competitions document store from the tofficial service.
         *
         * @memberof CompetitionInitService
         */
        this.competitionDocumentsStore = new CompetitionDocumentStore(this.http, this.injector);
        /**
         * The competition editorial information store.
         *
         * @memberof CompetitionInitService
         */
        this.competitionEditorialInformationStore = new CompetitionInformationStore(this.http, this.injector);
        /**
         * The competition quotes store.
         *
         * @memberof CompetitionInitService
         */
        this.competitionQuotes = new QuotesCompetitionStore(this.http, this.injector, undefined);
    }
    /**
     * Method for get the photos from api.
     *
     * @memberof CompetitionInitService
     */
    getPhotos() {
        return this.competitionGalleryStore.requestData({}, false);
    }
    /**
   * A method for prepare the competition name for route
   * @returns {string} the competition name with '-' instead spaces.
   * @memberof CompetitionInitService
   */
    prepareNameForRoute(name) {
        // TO DO make the name the same https://worldarchery.sport/competition/19890/medellin-2019-archery-world-cup-world-ranking-event#/#official
        let namePrepared = name.toLocaleLowerCase().split(' ').join('-').split('/').join('-');
        if (namePrepared.substr(namePrepared.length - 1, 1) === '-') {
            namePrepared = namePrepared.substring(0, namePrepared.length - 1);
        }
        return namePrepared;
    }
    /**
     * Method for get the competition name in the router and pass it to Angular js.
     *
     * @returns
     * @memberof CompetitionInitService
     */
    getCompetitionNameAndIdForRouterNavigate() {
        const name = this.prepareNameForRoute(this.competitionStore.data[0].Name);
        const competitionID = this.competitionStore.data[0].ID;
        return {
            name: name,
            id: competitionID
        };
    }
}
CompetitionInitService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CompetitionInitService_Factory() { return new CompetitionInitService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i0.INJECTOR)); }, token: CompetitionInitService, providedIn: "root" });
